import React from 'react';
import {productStatusDescription} from '../productsAndServicesBlockSlice';

const ProductStatus = (props) => {
  return (
    <div className={`product_status ${props.status.toLowerCase()}`}>{productStatusDescription[props.status.trim().toUpperCase()]}</div>
  );
};
export default ProductStatus;
